import axios from 'axios'

const API_BASE = process.env.VUE_APP_TICKETS_API_URL || 'https://erp.intrare.app'
const API_KEY = process.env.VUE_APP_TICKETS_API_KEY

const instance = axios.create({
  baseURL: API_BASE,
  headers: {
    'X-API-Key': API_KEY,
    'Content-Type': 'application/json'
  }
})

export const ticketsService = {
  async getAreas () {
    try {
      const response = await instance.get('/api/areas')
      return response.data
    } catch (error) {
      console.error('Error al obtener áreas:', error)
      throw error
    }
  },

  async getAllTickets (limit = 100) {
    try {
      const response = await instance.get(`/api/tickets?limit=${limit}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener tickets:', error)
      throw error
    }
  },

  async getTicketsByEmail (email, limit = 50) {
    try {
      const response = await instance.get(`/api/tickets?email=${email}&limit=${limit}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener tickets del usuario:', error)
      throw error
    }
  },

  async getTicketById (id) {
    try {
      const response = await instance.get(`/api/ticket/${id}`)
      let ticketData = response.data && response.data.data
      if (Array.isArray(ticketData)) {
        ticketData = ticketData[0] || null
      }
      return {
        success: response.data ? response.data.success : true,
        data: ticketData
      }
    } catch (error) {
      console.error('Error al obtener ticket:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  },

  async createTicket (data) {
    try {
      const response = await instance.post('/api/tickets', {
        title: data.title,
        description: data.description || '',
        area_id: data.area_id,
        client_name: data.client_name || '',
        client_email: data.client_email || '',
        client_phone: data.client_phone || '',
        client_company: data.client_company || ''
      })
      return response.data
    } catch (error) {
      console.error('Error al crear ticket:', error)
      throw error
    }
  },

  async respondQuote (ticketId, payload) {
    try {
      const response = await instance.post(`/api/ticket/${ticketId}/respond-quote`, payload)
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error respondiendo cotización:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  },

  async updateTicketInvoice (ticketId, payload) {
    try {
      const response = await instance.post(`/api/ticket/${ticketId}/invoice`, payload)
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      }
    } catch (error) {
      console.error('Error guardando información fiscal/factura:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  },

  async getClientFiscalInfo (email) {
    try {
      const response = await instance.get(`/api/client/fiscal-info?email=${encodeURIComponent(email)}`)
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo datos fiscales del cliente:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }
}

export default ticketsService
